module.exports = __webpack_public_path__ + "static/media/finish_line_1.622c3303.svg";